import {
  ChevronLeft,
  CircleCheck,
  SquareArrowOutUpRightIcon,
} from "lucide-react";
import { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import loopqueryImg from "../../../Assets/images/loopQueryImg.png";
import Loopview from "../../../Components/loopSession/loopview";
import "../../../Components/loopSession/loopview.css";
import ImagePath from "../../../constants/ImagePath";
import Footer from "../../MainLayout/Footer/Footer";
import "./loopsession.css";
import { IMG_PATH } from "../../../server";
import bookIcon from "../../../Assets/images/iconsBooks.svg";

const Loopsession = ({
  closeModal,
  loopSession,
  courseId,
  subject,
  articles,
  keytools,
  onLoopComplete, // Add this prop
  loopId, // Add unique identifier for the loop
  selectedTutor,
  currentOutlineDetail,
}) => {
  const steps = ["Learn", "Quiz", "Apply", "Support", "Finish"];

  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [enquiryModal, setEnquiryModal] = useState(false);
  const [exitModal, setExitModal] = useState(false);
  const [isCompletedCalled, setIsCompletedCalled] = useState(false);

  const openSupportModal = () => setEnquiryModal(true);
  const openSupportClose = () => setEnquiryModal(false);
  const openExitModal = () => setExitModal(true);
  const closeExitModal = () => setExitModal(false);
  const navigateTo = () => navigate("/SettingContentSupport");

  useEffect(() => {
    if (
      currentStep === loopSession.length - 1 &&
      typeof onLoopComplete === "function" &&
      loopId &&
      !isCompletedCalled
    ) {
      onLoopComplete(loopId);
      setIsCompletedCalled(true);
    }
  }, [
    currentStep,
    loopSession.length,
    onLoopComplete,
    loopId,
    isCompletedCalled,
  ]);

  const selectedTutorId =
    selectedTutor?.expertId ||
    selectedTutor?._id ||
    selectedTutor?.user_id ||
    null;

  // answerId: prefer currentOutlineDetail.Answer[0]._id, then try loopSession[currentStep]._id, then fallback to loopId
  const answerId =
    currentOutlineDetail?.Answer?.[0]?._id ||
    loopId ||
    null;

  const isPhone = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const supportLink = isPhone
    ? "mailto:hello@recess.education" // Mobile → mail app
    : "https://mail.google.com/mail/?view=cm&fs=1&to=hello@recess.education"; // Desktop → Gmail compose

  return (
    <div className="maincontainer">
      {/* Header */}
      <div className="headersection d-flex justify-content-between align-items-center pb-3 border-bottom">
        {currentStep > 0 && (
          <div
            className=" py-1.5 px-2 cursor-pointer font-avenir font-semibold d-lg-none"
            onClick={() => setCurrentStep(currentStep - 1)}
          >
            <ChevronLeft className="inline" />
            Back
          </div>
        )}

        <span
          className="d-flex align-items-center back-button"
          onClick={closeModal}
        >
          <span className="header-title">loop.</span>
        </span>
        <div className="d-flex align-items-center gap-3">
          <div
            onClick={openSupportModal}
            className="'w-8 h-8 flex items-center justify-center rounded hover:bg-gray-200 cursor-pointer modalbackgroundcolor"
          >
            <img
              src={ImagePath.enquiryicon}
              className="w-5 h-5"
              alt="enquiry icon"
            />
          </div>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={openExitModal}
          ></button>
        </div>
      </div>

      {/* Mobile Steps */}
      <div className="Stepmobileconatiner">
        {steps.map((_, index) => (
          <div
            key={index}
            className={`mobile-step-dot ${
              index <= currentStep ? "active" : ""
            }`}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="contentsection">
        {/* Desktop Steps */}
        <div className="Stepconatiner">
          {steps.map((step, index) => (
            <div
              key={index}
             className={`
  listview
  ${index < currentStep ? "Comlistview" : ""}
  ${index === currentStep ? "active-step" : ""}
`}
            >
              <span className="d-flex align-items-center gap-2">
                {currentStep === index && <span className="current-dot" />}
                {index + 1} {step}
              </span>

              {index < currentStep && <CircleCheck className="done-icon" />}
            </div>
          ))}

          {currentStep > 0 && (
            <div
              className="border py-1.5 px-2 rounded-2 mt-2 cursor-pointer d-inline-block"
              onClick={() => setCurrentStep(currentStep - 1)}
            >
              <ChevronLeft className="inline mr-2" />
              Back
            </div>
          )}
        </div>

        {/* Right Slide and Next Step */}
        <div className="Rightslidercontainer">
          <Loopview
            index={currentStep}
            stepName={steps[currentStep]}
            totalSteps={5}
            data={loopSession[currentStep]}
            closeModal={closeModal}
            subject={subject}
            articles={articles}
            fullData={loopSession}
            courseId={courseId}
            keytools={keytools}
            currentStep={currentStep}
            selectedTutor={selectedTutor}
            currentOutlineDetail={currentOutlineDetail}
            /* NEW props */
            selectedTutorId={selectedTutorId}
            answerId={answerId}
            onNext={() => {
              setCurrentStep((prev) => {
                if (prev < 4) {
                  return prev + 1;
                }
                return prev;
              });
            }}
          />

          {/* Key Tools on Desktop */}
          <div
            className="upcomestepviewConatiner"
            // style={{
            //   backgroundColor: currentStep === 0 ? "#f5f3ee" : "#E6F0F24D", // cream for first, blue for others
            //   // boxShadow: currentStep !== 0 ? "-2px 2px 1px 1px #00000040" : "none",
            //   boxShadow: currentStep !== 0 ? "0 0 4px 1px #00000030" : "none",
            // }}
            style={{
              backgroundColor: "#f5f3ee", // ✅ always same cream background
              // boxShadow: "0 0 4px 1px #00000030", // ✅ optional subtle shadow
            }}
          >
            {keytools?.length > 0 && (
              <>
                <h3 className="text-base font-recoleta mb-4">Key Tools</h3>
                {keytools.map((tool, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      if (tool.subjectUrl) {
                        window.open(tool.subjectUrl, "_blank");
                      }
                    }}
                    className="border border-[#D0D0D0] p-3 mb-3 rounded-lg flex items-center gap-2 hover:shadow-md bg-white cursor-pointer transition-transform hover:scale-[1.01]"
                  >
                    <div className="flex-shrink-0 flex items-center justify-center w-12 h-12">
                      <img
                        src={tool.image ? `${IMG_PATH}${tool.image}` : bookIcon}
                        alt={tool.toolName}
                        className="w-10 h-10 mr-2  rounded-[8px] "
                      />
                    </div>
                    <div className="flex flex-col justify-center flex-1">
                      <p className="font-semibold mb-1">
                        {tool.toolName}
                        {tool.subjectUrl && (
                          <SquareArrowOutUpRightIcon className="inline text-black ml-1 w-3 h-3" />
                        )}
                      </p>
                      <p className="text-xs text-black font-semibold mb-1">
                        {tool.description}
                      </p>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Enquiry Modal */}
      {enquiryModal && <div className="loop-dark-overlay"></div>}

      <Modal
        centered
        show={enquiryModal}
        onHide={openSupportClose}
        className="items-center m-0"
      >
        <div className="modalbackgroundcolor rounded-3">
          <div className="relative w-full mb-0">
            <img
              src={loopqueryImg}
              alt="query_image1"
              className="w-full  px-0 py-0 object-cover"
            />
            <div className="xmark position-absolute top-3 end-3 color-white">
              <button
                type="button"
                className="btn btn-close color-white bg-white"
                onClick={openSupportClose}
              ></button>
            </div>
          </div>

          <div className="p-4 d-flex flex-column justify-content-center align-items-center text-center mt-1">
            <dt className="sortHeading ">How Loops Work</dt>
            <p className="text-muted mb-3 mt-2 fw-medium">
              Loops help you learn one concept at a time through short videos,
              real world examples, practice activities, and guided support built
              into the experience.
            </p>
            <p className="text-muted mb-3 mt-2 fw-medium">
              Each one takes less than 30 minutes.
            </p>
            <p className="text-muted mb-3 mt-2 fw-medium">
              You will get help when you need it and earn a badge after
              completing every loop in a course.
            </p>

            <button
              onClick={() => openSupportClose()}
              className="w-100 bg-dark text-white rounded-md fw-medium hover:bg-secondary transition py-2"
            >
              Continue Learning
            </button>

            <div className="text-center mt-4">
              <p className="text-muted fw-medium mb-0">
                Need help? You can always{" "}
                {/* <span
                  className="fw-bold text-black cursor-pointer"
                  onClick={navigateTo}
                >
                  Contact Support.
                </span> */}
                <a
                  href={supportLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-medium text-neutral-900 underline hover:text-gray-500 transition-colors duration-200"
                >
                  Contact Support.
                </a>
              </p>
            </div>
          </div>
        </div>
      </Modal>

      {/* Exit Modal */}
      {exitModal && <div className="loop-dark-overlay"></div>}
      <Modal
        centered
        show={exitModal}
        onHide={closeExitModal}
        className="flex items-center m-0 rad"
      >
        <Modal.Body className="modalbackgroundcolor p-4 items-center rounded-lg">
          <Modal.Header
            className="btn btn-close ms-auto"
            onClick={closeExitModal}
          ></Modal.Header>

          <div className="signoutheadingtext mx-3">
            Are you sure you want <br /> to exit this loop?
          </div>

          <h4 className="headingtexts mt-1">
            Your progress will not be saved.
          </h4>
          <img
            src={ImagePath.wavesimage}
            alt="wallet icon"
            className="wavasimge"
          />

          <div className="d-flex justify-content-center mb-5">
            <Button
              variant="dark"
              onClick={closeModal}
              className="signoutbutton yesbtn"
            >
              Yes
            </Button>
            <Button
              variant="outline-dark"
              className="ms-3 signoutbutton cancelbtn"
              onClick={closeExitModal}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <footer className="border-top">
        <Footer />
      </footer>
    </div>
  );
};

export default Loopsession;

{
  /* {currentStep === 0 && keytools?.length > 0 && (
              <>
                <h3 className="text-base font-recoleta mb-4">Key Tools</h3>
                {keytools.map((tool, index) => (
                  <div
                    key={index}
                    className="p-2 mb-2 rounded-lg flex items-start gap-2 hover:shadow-md bg-white border"
                  >
                    <img
                      src={tool.image ? `${IMG_PATH}${tool.image}` : bookIcon}
                      alt={tool.toolName}
                      className="w-10 h-10 mr-2"
                    />
                    <div>
                      <p className="font-semibold mb-1">{tool.toolName}</p>
                      <p className="text-xs text-black font-semibold">
                        {tool.description}
                      </p>
                    </div>
                  </div>
                ))}
              </>
            )} */
}
{
  /* {keytools?.length > 0 && (
  <>
    <h3 className="text-base font-recoleta mb-4">Key Tools</h3>
    {keytools.map((tool, index) => (
      <div
        key={index}
        className="p-2 mb-2 rounded-lg flex items-start gap-2 hover:shadow-md bg-white"
      >
        <img
          src={tool.image ? `${IMG_PATH}${tool.image}` : bookIcon}
          alt={tool.toolName}
          className="w-10 h-10 mr-2"
        />
        <div>
          <p className="font-semibold mb-1">{tool.toolName}</p>
          <p className="text-xs text-black font-semibold">
            {tool.description}
          </p>
        </div>
      </div>
    ))}
  </>
)} */
}
